module.exports = __webpack_public_path__ + "static/media/icon_download.bed73a02.svg";